// src/utils/getBaseUrl.ts
export function getBaseUrl(req?: { headers: { host?: string } }): string {
    if (typeof window !== "undefined") {
      // Client side
      return window.location.origin;
    }

    // Server side
    if (req?.headers?.host) {
      const protocol = req.headers.host.includes("localhost") ? "http" : "https";
      return `${protocol}://${req.headers.host}`;
    }

    // Fallback jika tidak ada request object (misalnya di build time)
    return process.env.NEXT_PUBLIC_SITE_URL || "https://grasitech.com";
  }
